import { IconNames, l } from '@manychat/manyui'

import { routesGroups } from 'utils/router/constants'
import { isPathnameMatchRoute } from 'utils/router/tools'

export enum NavigationRouteIds {
  HOME = 'home',
  CONTACTS = 'contacts',
  CMS = 'cms',
  AI = 'ai',
  CHAT = 'chat',
  BROADCASTS = 'broadcasts',
  PAID_MESSAGES = 'paid_messages',
  SETTINGS = 'settings',
  MARKETING_MESSAGE_TEMPLATES_ANALYTICS = 'marketing_message_templates_analytics',
  ANALYTICS = 'analytics',
}

export interface NavigationRoute {
  id: NavigationRouteIds
  label: l.MakeTranslateReturnValue
  url: string
  icon: IconNames
  testId: string
  isActive?: (route?: string) => boolean
  state?: Record<string, unknown>
}

export const DUMMY_MODE_EXCLUDED_IDS = new Set<NavigationRouteIds>([
  NavigationRouteIds.HOME,
  NavigationRouteIds.SETTINGS,
])

export const navigationRoutes: NavigationRoute[] = [
  {
    id: NavigationRouteIds.HOME,
    label: l.makeTranslate('Home'),
    url: '/dashboard',
    icon: 'Home',
    isActive: () => routesGroups.HOME.some(isPathnameMatchRoute),
    testId: 'dashboard',
  },
  {
    id: NavigationRouteIds.CONTACTS,
    label: l.makeTranslate('Contacts'),
    url: '/subscribers',
    icon: 'User',
    testId: 'contacts',
  },
  {
    id: NavigationRouteIds.CMS,
    label: l.makeTranslate('Automation'),
    url: '/cms',
    icon: 'Automation',
    testId: 'cms',
  },
  {
    id: NavigationRouteIds.AI,
    label: l.makeTranslate('Manychat AI'),
    url: '/ai',
    icon: 'AiOutlined',
    testId: 'ai',
  },
  {
    id: NavigationRouteIds.CHAT,
    label: l.makeTranslate('Inbox'),
    url: '/chat',
    icon: 'LiveChat',
    testId: 'chat',
  },
  {
    id: NavigationRouteIds.ANALYTICS,
    label: l.makeTranslate('Analytics'),
    url: '/analytics',
    icon: 'Analytics',
    testId: 'analytics',
  },
  {
    id: NavigationRouteIds.MARKETING_MESSAGE_TEMPLATES_ANALYTICS,
    label: l.makeTranslate('Marketing Analytics'),
    url: '/marketing-message-templates-analytics',
    icon: 'WhatsAppWidget',
    testId: 'marketing-message-templates-analytics',
    state: { source: 'menu' },
  },
  {
    id: NavigationRouteIds.BROADCASTS,
    label: l.makeTranslate('Broadcasts'),
    url: '/posting',
    testId: 'broadcasts',
    icon: 'Broadcasting',
  },
  {
    id: NavigationRouteIds.PAID_MESSAGES,
    label: l.makeTranslate('Paid Messages'),
    url: '/sm',
    testId: 'sm',
    icon: 'OrphanBuyButton',
  },
  {
    id: NavigationRouteIds.SETTINGS,
    label: l.makeTranslate('Settings'),
    url: '/settings',
    icon: 'Settings',
    testId: 'settings',
    isActive: () => routesGroups.SETTINGS.some(isPathnameMatchRoute),
  },
]
